module.exports = __webpack_public_path__ + "media/assets/icons/ic-chevron-down-e27ca2ad2a6fc4ffcc49b9e600c0242a.svg";